import React, { useEffect, useRef } from 'react';

const CareersPage = () => {
  const observerRef = useRef(null);

  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    observerRef.current = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.animation = 'fadeInUp 0.8s ease-out forwards';
        }
      });
    }, observerOptions);

    const animatedElements = document.querySelectorAll('.animate-on-scroll');
    animatedElements.forEach(el => {
      el.style.opacity = '0';
      el.style.transform = 'translateY(30px)';
      observerRef.current.observe(el);
    });

    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
      }
    };
  }, []);

  const contactInfo = [
    {
      title: "HR Department",
      icon: "fas fa-users",
      address: "B B Industry Complex",
      location: "Sudpara, Bolangir-767001, Odisha, India",
      phone: "+91 94370 31796",
      email: "roshanprasad.sbmi@gmail.com",
      hours: "Mon - Fri: 9:00 AM - 5:00 PM"
    },
    {
      title: "Recruitment Office",
      icon: "fas fa-handshake",
      address: "Commercial Complex",
      location: "Sudpara, Bolangir-767001, Odisha, India",
      phone: "+91 78736 48033",
      email: "avinashagr91@gmail.com",
      hours: "Mon - Sat: 10:00 AM - 6:00 PM"
    }
  ];

  const benefits = [
    {
      title: "Competitive Salary",
      description: "Industry-leading compensation packages with performance-based incentives",
      icon: "fas fa-rupee-sign"
    },
    {
      title: "Health Insurance",
      description: "Comprehensive medical coverage for employees and their families",
      icon: "fas fa-heartbeat"
    },
    {
      title: "Professional Development",
      description: "Training programs, workshops, and skill development opportunities",
      icon: "fas fa-graduation-cap"
    },
    {
      title: "Work-Life Balance",
      description: "Flexible working arrangements and wellness programs",
      icon: "fas fa-balance-scale"
    },
    {
      title: "Career Growth",
      description: "Clear advancement paths and leadership development programs",
      icon: "fas fa-chart-line"
    },
    {
      title: "Modern Workplace",
      description: "State-of-the-art facilities with latest technology and equipment",
      icon: "fas fa-building"
    }
  ];

  const workCulture = [
    {
      title: "Innovation Driven",
      description: "Encouraging creative thinking and innovative solutions in metal processing",
      icon: "fas fa-lightbulb",
      color: "#7B3FE4"
    },
    {
      title: "Team Collaboration",
      description: "Working together across departments to achieve common goals and excellence",
      icon: "fas fa-users",
      color: "#14B87A"
    },
    {
      title: "Quality Focus",
      description: "Commitment to delivering the highest quality products and services",
      icon: "fas fa-award",
      color: "#FF6B35"
    },
    {
      title: "Continuous Learning",
      description: "Supporting employee growth through training and skill development",
      icon: "fas fa-book",
      color: "#9A60FF"
    }
  ];

  return (
    <div className="careers-page">
      <style jsx>{`
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        .careers-page {
          font-family: 'Inter', 'Poppins', sans-serif;
          line-height: 1.6;
          color: #1E2329;
          overflow-x: hidden;
        }

        /* Hero Section */
        .hero {
          background: linear-gradient(135deg, #5A1FB3 0%, #1E2329 100%);
          padding: 120px 0 80px;
          position: relative;
          overflow: hidden;
        }

        .hero::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 100" fill="%23ffffff" opacity="0.05"><polygon points="0,0 1000,0 1000,100 0,80"/></svg>');
          background-size: cover;
        }

        .hero-content {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 2rem;
          text-align: center;
          position: relative;
          z-index: 2;
        }

        .hero h1 {
          font-size: 3.5rem;
          font-weight: 800;
          color: white;
          margin-bottom: 1.5rem;
          line-height: 1.2;
        }

        .hero-subtitle {
          font-size: 1.3rem;
          color: rgba(255, 255, 255, 0.9);
          max-width: 800px;
          margin: 0 auto 2rem;
          font-weight: 400;
        }

        .hero-icon {
          width: 80px;
          height: 80px;
          background: #7B3FE4;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 2rem;
          box-shadow: 0 10px 30px rgba(123, 63, 228, 0.3);
        }

        .hero-icon i {
          font-size: 2rem;
          color: white;
        }

        /* Container */
        .container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 2rem;
        }

        .section-header {
          text-align: center;
          margin-bottom: 4rem;
        }

        .section-header h2 {
          font-size: 2.8rem;
          font-weight: 700;
          background: linear-gradient(135deg, #7B3FE4 0%, #5A1FB3 100%);
          background-clip: text;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          margin-bottom: 1rem;
        }

        .section-header p {
          font-size: 1.2rem;
          color: #4A5260;
          max-width: 600px;
          margin: 0 auto;
        }

        /* Contact Info Section */
        .contact-info-section {
          padding: 100px 0;
          background: #F6F7F9;
        }

        .contact-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
          gap: 2.5rem;
        }

        .contact-card {
          background: white;
          padding: 3rem;
          border-radius: 20px;
          box-shadow: 0 20px 60px rgba(0, 0, 0, 0.08);
          transition: all 0.5s ease;
          position: relative;
          overflow: hidden;
        }

        .contact-card::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 5px;
          background: linear-gradient(90deg, #7B3FE4, #9A60FF);
        }

        .contact-card:hover {
          transform: translateY(-10px);
          box-shadow: 0 30px 80px rgba(0, 0, 0, 0.12);
        }

        .contact-header {
          display: flex;
          align-items: center;
          margin-bottom: 2rem;
        }

        .contact-icon {
          width: 70px;
          height: 70px;
          background: linear-gradient(135deg, #7B3FE4, #9A60FF);
          border-radius: 15px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 1.5rem;
          transition: all 0.3s ease;
        }

        .contact-card:hover .contact-icon {
          transform: scale(1.1) rotate(5deg);
        }

        .contact-icon i {
          font-size: 2rem;
          color: white;
        }

        .contact-card h3 {
          font-size: 1.8rem;
          font-weight: 700;
          color: #1E2329;
          margin-bottom: 0.5rem;
        }

        .contact-details {
          space-y: 1rem;
        }

        .contact-item {
          display: flex;
          align-items: center;
          margin-bottom: 1rem;
          padding: 0.75rem;
          background: #F6F7F9;
          border-radius: 10px;
          transition: all 0.3s ease;
        }

        .contact-item:hover {
          background: rgba(123, 63, 228, 0.1);
          transform: translateX(5px);
        }

        .contact-item i {
          font-size: 1rem;
          color: #7B3FE4;
          margin-right: 0.75rem;
          width: 20px;
        }

        .contact-item span {
          color: #4A5260;
          font-weight: 500;
        }

        .contact-item a {
          color: #4A5260;
          text-decoration: none;
          transition: color 0.3s ease;
          word-break: break-word;
          overflow-wrap: break-word;
          hyphens: auto;
        }

        .contact-item a:hover {
          color: #7B3FE4;
        }

        /* Benefits Section */
        .benefits-section {
          padding: 100px 0;
          background: white;
        }

        .benefits-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
          gap: 2.5rem;
        }

        .benefit-card {
          background: #F6F7F9;
          padding: 3rem 2.5rem;
          border-radius: 20px;
          text-align: center;
          transition: all 0.4s ease;
          border: 2px solid transparent;
        }

        .benefit-card:hover {
          border-color: #7B3FE4;
          transform: translateY(-8px);
          box-shadow: 0 20px 50px rgba(123, 63, 228, 0.15);
        }

        .benefit-icon {
          width: 80px;
          height: 80px;
          background: linear-gradient(135deg, #7B3FE4, #9A60FF);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 1.5rem;
          transition: all 0.3s ease;
        }

        .benefit-card:hover .benefit-icon {
          transform: scale(1.1);
        }

        .benefit-icon i {
          font-size: 2rem;
          color: white;
        }

        .benefit-card h3 {
          font-size: 1.3rem;
          font-weight: 600;
          color: #1E2329;
          margin-bottom: 1rem;
        }

        .benefit-card p {
          color: #4A5260;
          line-height: 1.7;
        }

        /* Work Culture Section */
        .culture-section {
          padding: 100px 0;
          background: linear-gradient(135deg, #5A1FB3 0%, #1E2329 100%);
          color: white;
        }

        .culture-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
          gap: 2.5rem;
        }

        .culture-card {
          background: rgba(255, 255, 255, 0.1);
          padding: 3rem 2.5rem;
          border-radius: 20px;
          text-align: center;
          backdrop-filter: blur(10px);
          border: 1px solid rgba(255, 255, 255, 0.2);
          transition: all 0.4s ease;
        }

        .culture-card:hover {
          background: rgba(255, 255, 255, 0.15);
          transform: translateY(-8px);
        }

        .culture-icon {
          width: 80px;
          height: 80px;
          background: var(--color, #7B3FE4);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 1.5rem;
          transition: all 0.3s ease;
        }

        .culture-card:hover .culture-icon {
          transform: scale(1.1);
        }

        .culture-icon i {
          font-size: 2rem;
          color: white;
        }

        .culture-card h3 {
          font-size: 1.4rem;
          font-weight: 600;
          margin-bottom: 1rem;
        }

        .culture-card p {
          opacity: 0.9;
          line-height: 1.7;
        }

        /* Application Process Section */
        .process-section {
          padding: 100px 0;
          background: #F6F7F9;
        }

        .process-steps {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
          gap: 2rem;
        }

        .process-step {
          background: white;
          padding: 2.5rem;
          border-radius: 15px;
          text-align: center;
          position: relative;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
          transition: all 0.3s ease;
        }

        .process-step:hover {
          transform: translateY(-5px);
          box-shadow: 0 20px 50px rgba(0, 0, 0, 0.12);
        }

        .step-number {
          position: absolute;
          top: -15px;
          left: 50%;
          transform: translateX(-50%);
          width: 40px;
          height: 40px;
          background: linear-gradient(135deg, #7B3FE4, #9A60FF);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-weight: 700;
          font-size: 1.2rem;
        }

        .process-step h4 {
          font-size: 1.3rem;
          color: #1E2329;
          margin: 1rem 0;
          font-weight: 600;
        }

        .process-step p {
          color: #4A5260;
          line-height: 1.6;
        }

        /* CTA Section */
        .cta-section {
          padding: 100px 0;
          background: linear-gradient(135deg, #1E2329 0%, #4A5260 100%);
          text-align: center;
          color: white;
        }

        .cta-content h2 {
          font-size: 2.8rem;
          font-weight: 700;
          margin-bottom: 1.5rem;
        }

        .cta-content p {
          font-size: 1.3rem;
          margin-bottom: 2.5rem;
          max-width: 700px;
          margin-left: auto;
          margin-right: auto;
          opacity: 0.9;
        }

        .cta-buttons {
          display: flex;
          gap: 1.5rem;
          justify-content: center;
          flex-wrap: wrap;
        }

        .cta-button {
          display: inline-block;
          padding: 18px 40px;
          background: white;
          color: #7B3FE4;
          text-decoration: none;
          border-radius: 50px;
          font-weight: 700;
          font-size: 1.1rem;
          transition: all 0.4s ease;
          cursor: pointer;
          border: none;
          box-shadow: 0 10px 30px rgba(255, 255, 255, 0.2);
        }

        .cta-button:hover {
          transform: translateY(-3px) scale(1.05);
          box-shadow: 0 15px 40px rgba(255, 255, 255, 0.3);
        }

        .cta-button-secondary {
          background: transparent;
          color: white;
          border: 2px solid white;
        }

        .cta-button-secondary:hover {
          background: white;
          color: #7B3FE4;
        }

        /* Responsive Design */
        @media (max-width: 768px) {
          .hero h1 {
            font-size: 2.5rem;
          }

          .hero-subtitle {
            font-size: 1.1rem;
          }

          .section-header h2 {
            font-size: 2.2rem;
          }

          .container {
            padding: 0 1rem;
          }

          .contact-grid {
            grid-template-columns: 1fr;
          }

          .contact-card {
            padding: 2rem;
          }

          .cta-buttons {
            flex-direction: column;
            align-items: center;
          }

          .process-steps {
            grid-template-columns: 1fr;
          }
        }

        /* Animations */
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .animate-fade-in {
          animation: fadeInUp 0.8s ease-out;
        }
      `}</style>

      <link href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.7.2/css/all.min.css" rel="stylesheet" />
      <link href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap" rel="stylesheet" />

      {/* Hero Section */}
      <section className="hero">
        <div className="hero-content">
          <div className="hero-icon animate-fade-in">
            <i className="fas fa-users"></i>
          </div>
          <h1 className="animate-fade-in">Join Our Team</h1>
          <p className="hero-subtitle animate-fade-in">
            Be part of India's leading aluminium manufacturing company and shape the future of metal industry innovation
          </p>
        </div>
      </section>

      {/* Contact Information Section */}
      <section className="contact-info-section">
        <div className="container">
          <div className="section-header">
            <h2>Get In Touch</h2>
            <p>Connect with our HR team for career opportunities and recruitment inquiries</p>
          </div>
          
          <div className="contact-grid">
            {contactInfo.map((contact, index) => (
              <div key={index} className="contact-card animate-on-scroll">
                <div className="contact-header">
                  <div className="contact-icon">
                    <i className={contact.icon}></i>
                  </div>
                  <h3>{contact.title}</h3>
                </div>
                
                <div className="contact-details">
                  <div className="contact-item">
                    <i className="fas fa-map-marker-alt"></i>
                    <span>{contact.address}</span>
                  </div>
                  <div className="contact-item">
                    <i className="fas fa-location-dot"></i>
                    <span>{contact.location}</span>
                  </div>
                  <div className="contact-item">
                    <i className="fas fa-phone"></i>
                    <a href={`tel:${contact.phone}`}>{contact.phone}</a>
                  </div>
                  <div className="contact-item">
                    <i className="fas fa-envelope"></i>
                    <a href={`mailto:${contact.email}`}>{contact.email}</a>
                  </div>
                  <div className="contact-item">
                    <i className="fas fa-clock"></i>
                    <span>{contact.hours}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="benefits-section">
        <div className="container">
          <div className="section-header">
            <h2>Why Work With Us</h2>
            <p>Comprehensive benefits and opportunities for professional growth</p>
          </div>
          
          <div className="benefits-grid">
            {benefits.map((benefit, index) => (
              <div key={index} className="benefit-card animate-on-scroll">
                <div className="benefit-icon">
                  <i className={benefit.icon}></i>
                </div>
                <h3>{benefit.title}</h3>
                <p>{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Work Culture Section */}
      <section className="culture-section">
        <div className="container">
          <div className="section-header">
            <h2 style={{color: 'white'}}>Our Work Culture</h2>
            <p style={{color: 'rgba(255,255,255,0.9)'}}>Values and principles that drive our team forward</p>
          </div>
          
          <div className="culture-grid">
            {workCulture.map((culture, index) => (
              <div key={index} className="culture-card animate-on-scroll">
                <div className="culture-icon" style={{'--color': culture.color}}>
                  <i className={culture.icon}></i>
                </div>
                <h3>{culture.title}</h3>
                <p>{culture.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Application Process Section */}
      <section className="process-section">
        <div className="container">
          <div className="section-header">
            <h2>Application Process</h2>
            <p>Simple steps to join our team and start your career journey with B B Industry</p>
          </div>
          
          <div className="process-steps">
            <div className="process-step animate-on-scroll">
              <div className="step-number">1</div>
              <h4>Submit Application</h4>
              <p>Send your resume and cover letter to our careers email or apply through job portals</p>
            </div>
            <div className="process-step animate-on-scroll">
              <div className="step-number">2</div>
              <h4>Initial Screening</h4>
              <p>Our HR team will review your application and contact qualified candidates</p>
            </div>
            <div className="process-step animate-on-scroll">
              <div className="step-number">3</div>
              <h4>Interview Process</h4>
              <p>Technical and HR interviews to assess your skills and cultural fit</p>
            </div>
            <div className="process-step animate-on-scroll">
              <div className="step-number">4</div>
              <h4>Final Selection</h4>
              <p>Offer letter and onboarding process to welcome you to our team</p>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action Section */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Start Your Career?</h2>
            <p>
              Join B B Industry and be part of a team that's shaping the future of aluminium manufacturing in India. 
              Send us your resume or explore our current openings.
            </p>
            <div className="cta-buttons">
              <button className="cta-button" onClick={() => window.location.href = 'mailto:roshanprasad.sbmi@gmail.com'}>
                Send Your Resume
              </button>
              <button className="cta-button cta-button-secondary" onClick={() => window.location.href = '/contact/overview'}>
                Contact HR Team
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CareersPage;